import serverConfig from '@jucy-nakuru/config/serverConfig';
import { ApiCacheStore, JucyCache, LocalStorageStore, MemoryStore } from '@jucy/cache';

export { CACHE_TTL } from '@jucy/cache';

export * from '@jucy/cache';

const getCacheStore = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
        return new LocalStorageStore();
    }

    if (typeof process !== 'undefined' && process.versions?.node && serverConfig.jucyCache.apiKey) {
        return new ApiCacheStore({ baseUrl: `${serverConfig.rentalsApi.baseUrl}/cache`, apiKey: serverConfig.jucyCache.apiKey, fetch: fetch });
    }

    return new MemoryStore();
};
type JucyGlobalCache = { jucyCache: Record<string, JucyCache> };
(global as unknown as JucyGlobalCache).jucyCache = {};
const jucyCache = (global as unknown as JucyGlobalCache).jucyCache;
export const getJucyCacheInstance = (name = '') => {
    const service = `nakuru-v3${name ? `-${name}` : ''}`;
    if (!jucyCache[service]) {
        jucyCache[service] = new JucyCache({
            service: service,
            store: getCacheStore(),
        });
    }
    return jucyCache[service];
};

export const cache = getJucyCacheInstance();
